/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
import Vue from 'vue';
// @ts-ignore
import momenthijri from 'moment-hijri';

import { i18n } from './plugins/i18n';

export function getSocialIdType(socialId: string) {
  if (!socialId) return '';
  if (socialId && socialId.startsWith('2')) {
    return i18n.t('iqama').toString();
  } if (socialId === '0' || socialId == null) {
    return i18n.t('nationalUnifiedNumber').toString();
  }
  return i18n.t('nationalId').toString();
}

export function getFormattedDate(date: string) {
  if (!date) return '';
  const splittedDate = date.split('T')[0];
  const splittedArr = splittedDate.split('-');
  const formatted = `${splittedArr[0]}/${splittedArr[1]}/${splittedArr[2]}`;
  return formatted;
}

export function getIndexedLetter(index: number) {
  const letters = ['أ', 'ب', 'ت', 'ث', 'ج', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ك', 'ل', 'م', 'ن', 'ه'];
  let selectedLetter = '';

  try {
    selectedLetter = letters[index];
  } catch (e) {
    return '';
  }

  return selectedLetter;
}

export function getIndexedClauseName(index: number) {
  const clauseNames = ['المادة الأولى', 'المادة الثانية', 'المادة الثالثة', 'المادة الرايعة', 'المادة الخامسة', 'المادة السادسة',
    'المادة السابعة', 'المادة الثامنة', 'المادة التاسعة', 'المادة العاشره', 'المادة الحادية عشر', 'المادة الثانية عشر', 'المادة الثالثة عشر', 'المادة الرابعة عشر', 'المادة الخامسة عشر', 'المادة السادسة عشر'];
  let selectedName = '';

  try {
    selectedName = clauseNames[index];
  } catch (e) {
    return 'مادة';
  }

  return selectedName;
}

export function fancyTimeFormat(duration: number) {
  // Hours, minutes and seconds
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;
  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = '';
  ret += `${(mins < 10 ? '0' : '') + mins}:${secs < 10 ? '0' : ''}`;
  ret += `${secs}`;
  return ret;
}

export function formatGregToHijri(date: string) {
  let hijriDate = 'invalid date';
  if (date) {
    const arr = date.split('T');
    if (arr?.length > 0) {
      momenthijri.locale('en-SA');
      hijriDate = momenthijri(arr[0], 'YYYY-MM-DD').format('iYYYY/iMM/iDD'); ;
    }
  }
  return hijriDate;
}
export function formatDateTime(date: Date | null, includeTime: boolean = false): string | null {
    if (!date) return null;
    const dateStr = date.toString();
    const formattedDate = getFormattedDate(dateStr);
    const dateHijri = formatGregToHijri(dateStr);
    let formattedTimeFromDate = '';
    if (includeTime) {
        formattedTimeFromDate = ` - ${formatTimeFromDate(dateStr)}`;
    }
    return `${dateHijri} هـ (${formattedDate}م)${formattedTimeFromDate}`;
}

export function formatTimeFromDate(jsonDate: string) {
  let formattedTime = 'invalid time';
  const date = new Date(jsonDate);
  if (date) {
    let hours = date.getHours(); // gives the value in 24 hours format
    const AmOrPm = hours >= 12 ? 'م' : 'ص';
    hours = (hours % 12) || 12;
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const formattedHours = (hours < 10) ? `0${hours}` : hours;
    formattedTime = `${formattedHours}:${formattedMinutes} ${AmOrPm}`;
  }

  return formattedTime;
}

Vue.filter('getSocialIdType', getSocialIdType);
Vue.filter('getFormattedDate', getFormattedDate);
Vue.filter('getIndexedLetter', getIndexedLetter);
Vue.filter('getIndexedClauseName', getIndexedClauseName);
Vue.filter('fancyTimeFormat', fancyTimeFormat);
Vue.filter('formatGregToHijri', formatGregToHijri);
Vue.filter('formatTimeFromDate', formatTimeFromDate);
Vue.filter('formatDateTime', formatDateTime);
